import { getState, setState } from '../../helpers';
/** Wheel zoom on cartesian plot — adjusts minY/maxY in widget state and rebuilds. */
export function attachPlotWheelZoom(group, hitArea, bounds, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var minSpan = (_a = options.minSpan) !== null && _a !== void 0 ? _a : 1;
    var factor = (_b = options.factor) !== null && _b !== void 0 ? _b : 1.12;
    var applyZoom = function (direction) {
        var _a, _b;
        var state = getState(group);
        var minY = typeof state.minY === 'number' ? state.minY : bounds.min;
        var maxY = typeof state.maxY === 'number' ? state.maxY : bounds.max;
        var mid = (minY + maxY) / 2;
        var half = ((maxY - minY) / 2) * (direction > 0 ? factor : 1 / factor);
        half = Math.max(minSpan / 2, half);
        setState(group, { minY: mid - half, maxY: mid + half });
        var rebuild = (_a = group.metadata) === null || _a === void 0 ? void 0 : _a.chartRebuild;
        rebuild === null || rebuild === void 0 ? void 0 : rebuild();
        (_b = group.getApp()) === null || _b === void 0 ? void 0 : _b.requestRender();
    };
    var onWheel = function (e) {
        var _a;
        var we = e.originalEvent;
        var dy = (_a = we.deltaY) !== null && _a !== void 0 ? _a : 0;
        if (dy === 0)
            return;
        e.preventDefault();
        e.stopPropagation();
        applyZoom(dy > 0 ? 1 : -1);
    };
    group.on('wheel', onWheel);
    hitArea.on('wheel', onWheel);
}
